import { stringify } from "query-string"

import { farasod } from "./api"

const endpoint = "/account"

export const getOnlyUserList = async queries => {
  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await farasod.get(`${endpoint}/userList/onlyUsers?${query}`)

  return response.data
}

export const getCustomerDashboard = async accountId => {
  const response = await farasod.get(`${endpoint}/user/${accountId}/dashboard`)

  return response.data
}

export const getsMostPurchaseUsers = async queries => {
  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await farasod.get(`${endpoint}/most/purchase?${query}`)

  return response.data
}
